/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";
import TEXT from "../../../../utils/globalText";
import SmallPopupWithInput from "../../CommonSmallPopupWithInput";
import CommonToast from "../../CommonToast/index.jsx";

import ICONS from "../../../../assets/Icons/index.js";
import { ReimbursementMultiTxnDeniedApproval } from "../../../../redux/features/reimbursementTransaction/index.js";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider.js";
import SmallPopupWithBulletPoints from "../../CommonSmallPopupWithBulletPoint/index.jsx";

const ReimbursementDeclinePopup = ({
  handleClose,
  txnId,
  allTxnData,
  updateAllTxn,
  flow = "",
}) => {
  const services = useSelector((state) => state.refreshToken.services);
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const isSubmittingRef = useRef(false);

  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [inputDisabled, setInputDisabled] = useState(false);

  const handleInputChange = (event) => {
    let value = event.target.value;

    // 1. Allow only alphanumeric + space
    value = value.replace(/[^a-zA-Z0-9\s]/g, "");

    // 2. Remove leading spaces
    value = value.replace(/^\s+/, "");

    // 3. Allow only one space between words
    value = value.replace(/\s{2,}/g, " ");

    // 4. Limit to 150 characters
    value = value.slice(
      GlobalConfiguration.lengthCheckZero,
      GlobalConfiguration.inputMaxLength,
    );

    setDeclineReason(value);
  };

  const handleTxnMultiRejecting = () => {
    setTimeout(() => {
      toast.dismiss();
    }, IntervalConfiguration.intervalExtraLarge);
  };

  const finalize = () => {
    setShowLoader(false);
    setInputDisabled(false);
    setDeclineReason("");
    handleClose();
  };

  const showLoadingToast = (txt) => {
    CommonToast({
      text: txt,
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });
  };

  const handleReject = async (id, reason) => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;

    try {
      if (
        services?.find(
          (service) => service === "AReimbursementTxn" || service === "Admin",
        ) !== undefined
      ) {
        // Token Check
        if (!sessionStorage.getItem("q2p_token")) {
          return;
        }

        setShowLoader(true);
        setInputDisabled(true);

        showLoadingToast("Rejecting transaction(s)");
        handleTxnMultiRejecting();

        const result = await dispatch(
          ReimbursementMultiTxnDeniedApproval({
            id,
            AccountIdData: reason,
            services,
            Navigate,
          }),
        );
        const payload = result?.payload;

        // wait for loader animation
        await new Promise((resolve) =>
          setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
        );

        if (payload?.status === errorcode.errorFailed) {
          CommonToast({
            text: payload?.error,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
            btnProps: {
              enabledBgColor: "var(--primary-bg)",
              enabledTextColor: "var(--text-primary)",
              btnText: "",
              handleFunction: () => {},
              icon: "",
              btnType: "button",
              isDisabled: false,
              hoverOption: "white",
            },
          });
          return finalize();
        }

        if (
          payload?.errors?.user_unauthorized?.[
            GlobalConfiguration.lengthCheckZero
          ]
        ) {
          Navigate("/feature_not_assigned", {
            state: { unavailableService: "AReimbursementTxn, Admin" },
          });
          return finalize();
        }

        // MULTI approval flow
        if (flow === "multiApproval" && payload) {
          if (payload?.status === false) {
            Navigate(
              "/reimbursement_transaction_dashboard/multi_approval/reimbursement_multi_transaction_error",
              {
                replace: true,
              },
            );
          } else {
            Navigate(
              "/reimbursement_transaction_dashboard/multi_approval/reimbursement_multi_transaction_declined",
              {
                replace: true,
              },
            );
          }
          return finalize();
        }

        // SINGLE approval flow
        const updatedData = allTxnData.map((item) => {
          if (item.txn_id !== id) return item;

          const tx =
            payload?.transactions?.[GlobalConfiguration.lengthCheckZero];
          let lifecycleStatus = "error";
          let errorMessage = "";

          // lifecycle status logic
          if (payload?.status === true) {
            lifecycleStatus =
              tx?.lifecycle_status === "rejected"
                ? "rejected"
                : tx?.lifecycle_status === "pending"
                  ? "pendingOne"
                  : "error";
          }

          // error message handling
          if (
            payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]?.errors
          ) {
            const errors =
              payload.errors.base[GlobalConfiguration.lengthCheckZero].errors;
            errorMessage = errors[GlobalConfiguration.lengthCheckZero];
          } else if (
            payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
          ) {
            errorMessage =
              payload.errors.base[GlobalConfiguration.lengthCheckZero];
          }

          return {
            ...item,
            lifecycle_status:
              item.lifecycle_status === "pending" && payload?.status === true
                ? lifecycleStatus
                : "error",
            rejected: true,
            rejection_reason: reason,
            error: payload?.status === false ? "true" : "false",
            message: payload?.status === false ? errorMessage : "",
          };
        });

        updateAllTxn(updatedData);

        // toast results
        if (payload?.status === false) {
          const err =
            payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
              ?.errors?.[GlobalConfiguration.lengthCheckZero] ||
            payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero] ||
            "Error occurred";

          CommonToast({
            text: err,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
            btnProps: {
              enabledBgColor: "var(--primary-bg)",
              enabledTextColor: "var(--text-primary)",
              btnText: "",
              handleFunction: () => {},
              icon: "",
              btnType: "button",
              isDisabled: false,
              hoverOption: "white",
            },
          });
        } else {
          CommonToast({
            text: "Reimbursement transactions rejected successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
            buttonNeeded: false,
            btnProps: {
              enabledBgColor: "var(--primary-bg)",
              enabledTextColor: "var(--text-primary)",
              btnText: "",
              handleFunction: () => {},
              icon: "",
              btnType: "button",
              isDisabled: false,
              hoverOption: "white",
            },
          });

          let storedData = JSON.parse(
            sessionStorage.getItem("selectedReimbursementTxnData"),
          );

          if (storedData) {
            const updatedTransactions =
              storedData.selectedSendTransactions?.filter(
                (txn) => txn.txn_id !== id,
              );

            const updatedTransactionIds =
              storedData.selectedTransactions?.filter((txnId) => txnId !== id);

            sessionStorage.setItem(
              "selectedReimbursementTxnData",
              JSON.stringify({
                ...storedData,
                selectedSendTransactions: updatedTransactions,
                selectedTransactions: updatedTransactionIds,
              }),
            );
          }
        }

        finalize();
      } else {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "AReimbursementTxn, Admin",
          },
        });
      }
    } finally {
      isSubmittingRef.current = false;
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      const emojiRegex =
        /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
      if (emojiRegex.test(event.key)) {
        event.preventDefault();
        return;
      }

      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();

        if (
          !inputDisabled &&
          declineReason.trim().length >=
            GlobalConfiguration.owneraccountnormalLength
        ) {
          handleReject(txnId, declineReason);
        }
      }

      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [inputDisabled, declineReason, txnId]);

  return (
    <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-fixed-ui bg-PopUp-BackDrop bg-opacity-dark-opacity">
      <SmallPopupWithBulletPoints
        headerTitle={TEXT?.REJECT_REASON_TXN}
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        textSize="font-md"
        subtext={TEXT?.PROVIDE_REJECT_REQUEST_REASON_PROMPT}
        noteText={TEXT?.MINIMUM_TEN_CHARACTER_REQUIRED_MGS}
        isTextInputField={true}
        inputPlaceholder="Reason"
        inputAdornment={false}
        subtextwithbullet="Y"
        bulletPoints={[
          "Transaction will be rejected, and distribution will not be initiated.",
          "Transaction cannot be edited.",
        ]}
        inputVariant={
          declineReason &&
          declineReason.length > GlobalConfiguration.accountnormalLength
            ? "verified"
            : declineReason &&
                declineReason.length < GlobalConfiguration.panLength
              ? "typing"
              : "default"
        }
        inputBgColor="var(--primary-bg)"
        inputFgColor="var(--text-secondary)"
        inputOnInput={(e) => {
          if (!showLoader) {
            handleInputChange(e);
          }
        }}
        inputValue={declineReason}
        inputFontKind="big"
        inputIsFullWidth={true}
        btnOneText={TEXT?.CANCEL}
        btnOneHandleFunction={() => {
          if (!showLoader) {
            handleClose();
          }
        }}
        btnOneEnabledBgColor="var(--primary-bg)"
        btnOneOutLineColor="var(--text-primary)"
        btnOneEnabledTextColor="var(--text-primary)"
        btnOneHoverOption="white"
        btnOneIsDisabled={showLoader}
        btnTwoText={TEXT.REJECT}
        btnTwoHandleFunction={() => {
          if (
            !declineReason ||
            declineReason.length < GlobalConfiguration.panLength ||
            showLoader
          ) {
            return;
          }
          handleReject(txnId, declineReason);
        }}
        btnTwoEnabledBgColor="var(--negative-act)"
        btnTwoEnabledTextColor="var(--text-primary)"
        btnTwoIsDisabled={
          !declineReason || declineReason.length < GlobalConfiguration.panLength
        }
        btnTwoDisabledBgColor="var(--text-disabled)"
        btnTwoIsLoaderNeeded={showLoader ? true : false}
        btnTwoIsLoading={showLoader ? true : false}
        btnTwoHoverOption="black"
        btnTwoInActiveVariantNeeded={true}
      />
    </div>
  );
};

export default ReimbursementDeclinePopup;
